import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=369e394c&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('369e394c')) {
      api.createRecord('369e394c', component.options)
    } else {
      api.reload('369e394c', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=369e394c&", function () {
      api.rerender('369e394c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-29oJ7h50f39IZ/JS/comp/childrenage.vue"
export default component.exports